import bind from '@/bookmarks/bind'

bind()
